import { PROPOSAL_QUERY } from '@services/permissions'

import type { Section } from '../types'

export const accountActivitySection: Section = {
  label: 'layout:page.accountActivity.title',
  route: '/account-activity',
  icon: 'BellOutline',
  permissions: PROPOSAL_QUERY,
  segment: {
    page: 'Account Activity',
  },
}
